import { CmsGridWrapper } from 'commonStyledComponents'
import VideoBox from 'component/VideoBoxVertical'
import { memo } from 'react'

interface Template8Props {
  videoData?: any[]
  trigger?: React.ReactNode
  currentLimit?: number
}

/**
 * 模板 ID: "8": 豎版一行兩個
 * */
function Template8({ videoData, trigger, currentLimit }: Template8Props) {
  return (
    <CmsGridWrapper>
      {videoData?.slice(0, currentLimit).map((item, i) => {
        return <VideoBox overflow={true} columns={2} key={i} videoInfo={item} allowUnload />
      })}
      {trigger}
    </CmsGridWrapper>
  )
}

// this indicate areaBox should hide bottom section until fully shown
;(Template8 as any).lazy = true
export default memo(Template8)
